
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/payment",
      function () {
        return require("private-next-pages/quick-purchase/payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quick-purchase/payment"])
      });
    }
  